// import Vue from 'vue'

const getters = {
  listAll: state => {
    return state.device_list
  }
  // listUploads: state => {
  //     // BELOW IS NOT WORKING
  //     console.log('listUploads')
  //     var arr = []
  //     for (let index = 0; index < state.file_list.length; index++) {
  //         if (state.file_list[index].medium.length == 0) arr.push(state.file_list[index])
  //     }
  //     // return state.file_list
  //     return arr
  // }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/device/device.getters.js
// module id = null
// module chunks = 